import { Component, OnInit, ChangeDetectorRef, Input, EventEmitter, Output } from '@angular/core';
import { AuthService, FacebookLoginProvider } from 'angularx-social-login';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Login } from '@app/core/user/store/actions';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { Credentials } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-facebook-connect',
  templateUrl: './facebook-connect.component.html',
  styleUrls: ['./facebook-connect.component.scss']
})
export class FacebookConnectComponent implements OnInit {
  @Input()
  type: string;
  @Input()
  registerScreen: boolean;

  @Output()
  registerNextStep = new EventEmitter<{ credentials: Credentials; firstname?: string }>();

  constructor(
    private socialAuthService: AuthService,
    private store: Store<IAppState>,
    public dialogRef: MatDialogRef<AuthModalComponent>,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {}

  public openFacebookConnect() {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then(userData => {
      const credentials: Credentials = {
        socialAccountType: 'facebook',
        socialId: userData.id,
        socialToken: userData.authToken,
        email: userData.email
      };

      const firstname = userData.firstName;

      if (this.type === 'register') {
        this.registerNextStep.emit({ credentials, firstname });
      } else {
        this.store.dispatch(new Login({ credentials, firstname }));
        this.ref.detectChanges();
      }
    });
  }
}
